import { render, staticRenderFns } from "./CoinPurchasePending.vue?vue&type=template&id=ec4e58ae&scoped=true"
import script from "./CoinPurchasePending.vue?vue&type=script&lang=ts"
export * from "./CoinPurchasePending.vue?vue&type=script&lang=ts"
import style0 from "./CoinPurchasePending.vue?vue&type=style&index=0&id=ec4e58ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4e58ae",
  null
  
)

export default component.exports